<template>
  <div class="section-faqlightbg" >
    <v-container class="py-12">
      <v-row class="display-1 font-weight-medium text-center">
        <v-col>
          <p><v-icon class="blink" color="primary">mdi-color-helper</v-icon>FAQ // Patrowl<span class="font-weight-bold primary--text">Hears</span></p>
        </v-col>
      </v-row>
      <v-row style="flex-wrap: wrap;">
        <!-- <v-col cols="6" xs="12"> -->
        <v-col>
          <v-expansion-panels focusable accordion class="pa-2">
            <v-expansion-panel v-for="item in qa_first" :key="item.question" >
              <v-expansion-panel-header>
                {{item.question}}
                <template v-slot:actions>
                  <v-icon color="primary">mdi-chevron-down</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-2">
                <div v-html="item.answer"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <!-- <v-col cols="6" xs="12"> -->
        <v-col>
          <v-expansion-panels focusable accordion class="pa-2">
            <v-expansion-panel v-for="item in qa_second" :key="item.question" >
              <v-expansion-panel-header>
                {{item.question}}
                <template v-slot:actions>
                  <v-icon color="primary">mdi-chevron-down</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-2">
                <div v-html="item.answer"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "SecFaqHears",
  data: () => ({
    qa_first: [
      {question: "What is Vulnerability Intelligence ?", answer: "Intelligence-driven Security or 'Vulnerability Intelligence' is an approach to manage cyber-threats as efficiently as possible. It helps to analyze vulnerabilities and prioritize remediation steps."},
      {question: "What king of data do you provide ?", answer: "We provide vulnerability, exploit and threat news. For savvy experts, it's about CVE, CWE, CPE, CVSS, Exploits, PoCs, threats metadata. PatrowlHears features and data are available independently through our Web UI or REST APIs. "},
      {question: "Tell me more about your scoring system ?", answer: "We continuously update Scores on vulnerabilities. These scores are based on 1. the intrinsic impact and pre-requisites needed to exploit the vulnerability, 2. the threat metadata collected from various public and private feeds, and 3. the asset criticality, distribution and exposure."},
      {question: "How to test PatrowlHears ?", answer: "Just create an account and request a Free subscription. It requires a credit card just to ensure you're a human and not abusing ;). Otherwise, the Community edition of PatrowlHears is available on our public Github repository. If you have a profesionnal usage, please consider our Support options and profesionnal services."},
    ],
    qa_second: [
      {question: "I only need Support, Is it possible ? Yes.", answer: "Support services could be provided without buying our products. For example, you are satisfied of the open-source version but you need  advanced assistance for your users and reactivity in case of issue. Of course, we would be glad to help you !"},
      {question: "Where my data are located ? In France by default.", answer: "Data and applications are hosted on OVH and AWS datacenters located in France. If you need to relocate your data in another country or region, please let us now."},
      {question: "How Patrowl sustains with free model ? It's in our DNA.", answer: "As security experts, we use tools for making our lifes easier. We use a lot of tools, and most of them are open-source. OSS projects imply transparency about their features and security, remove locks for custom usages and empower a community. -- Sharing is caring"},
      {question: "I have a lot of questions ? Great ! Let's talk.", answer: "Still looking for an answer ? Please reach out to us at <a href='mailto:getsupport@patrowl.io'>getsupport@patrowl.io </a> and we will try to reply back as soon as possible."},
    ],
  })
};
</script>

<style scoped>
a {
  color: #f57c00;
}

</style>

<style >
div .theme--light.v-card.v-card--outlined {
    border: no solid rgba(0,0,0,.12);
}

</style>
